// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Luxon from "luxon";

function dayMatches(zone, nowUtc) {
  return function (dateToCheck) {
    return nowUtc.setZone(zone).toFormat("MM-dd") === dateToCheck;
  };
}

function getUsersTimeZone() {
  return Luxon.DateTime.local().zoneName;
}

function makeDateCompareFn(zone) {
  var nowUtc = Luxon.DateTime.local();
  return dayMatches(zone, nowUtc);
}

export {
  dayMatches ,
  getUsersTimeZone ,
  makeDateCompareFn ,
}
/* luxon Not a pure module */
